<template>
  <div>
    <el-container style="height: 100vh;">
      <el-aside width="200px" style="background-color: #1F2D42">
        <Asides></Asides>
      </el-aside>
      <el-container>
<!--        :class="$route.path == '/Dispatch' && $route.path == '/dispatch_test" ? 'change':'' "-->
        <el-header  style="background-color: #F5F6FB" class="change">
          <Header></Header>
        </el-header>
        <el-main class="scoll_box" :class="$route.path == '/dirverMap' || $route.path == '/Dispatch'||  $route.path == '/dispatch_test' ? 'noPad':'Nomarl'">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Asides from "@/components/aside";
import Header from "@/components/header";
import store  from "@/store";
export default {
  components: {
    Asides,Header
  },
  created() {
    setTimeout(()=>{
      window.addEventListener("scroll", this.scrollFun,true);
    },1000)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFun)
  },
  methods:{
    scrollFun(){
      //监听滚动事件，将scrollTop存储vuex 在wage 页面监听取用
      let scrollTop = document.getElementsByClassName('scoll_box')[0].scrollTop;
      store.commit('sageWageScorll',scrollTop)
    }
  }
}
</script>
<!--style="background-color:#F5F6FB; padding:16px 24px"-->
<style scoped>
.noPad{
  background: #F5F6FB;
  padding: 0;
}
.Nomarl{
  background: #F5F6FB;
  padding: 16px 24px;
}
.change{
  height: 72px!important;
}
</style>
